import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import CompanyAcceptRequest from './notificationTypes/CompanyAcceptRequest';
import GeneralNotification from './notificationTypes/GeneralNotification';
import ProjectAcceptRequest from './notificationTypes/ProjectAcceptRequest';
import ReportGenMessage from './notificationTypes/ReportGenMessage';

class NotificationControl extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showNotificationModal: false,
        }
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({ showNotificationModal: true });
                break;
            }
            default: {
                this.setState({ showNotificationModal: false });
                break;
            }
        }
    }

    handleCloseModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({ showNotificationModal: false });
                break;
            }
            default: {
                this.setState({ showNotificationModal: false });
                break;
            }
        }
    }

    getRelevantComponent = (notificationItem) => {
        var requestCode = notificationItem.requestCode;

        /// DOCS: See notification reducer
        switch (requestCode) {
            case 0: {
                return <ProjectAcceptRequest notificationItem={notificationItem} />;
            }
            case 1: {
                return <CompanyAcceptRequest notificationItem={notificationItem} />;
            }
            case 5: {
                return <ReportGenMessage notificationItem={notificationItem} />;
            }
            default: {
                return <GeneralNotification notificationItem={notificationItem} />;
            }
        }
    }

    render() {
        const { notifUtils, notificationItem, modalStyles,
            modalTitleStyle, formLabelStyle, modalWidth,
        } = this.props;

        const { notificationColor, notificationIcon } = notifUtils;

        const relevantNotificationType = this.getRelevantComponent(notificationItem);

        return (
            <React.Fragment>
                <a href="#!" style={{ color: "#141414" }} key={notificationItem.timestamp} onClick={() => { this.handleOpenModal(0) }}>
                    <div className="d-flex" >
                        <div className="p-2 flex-fill" style={{ fontWeight: "bold" }}>{notificationItem.notify}</div>
                        <div className="p-2 flex-fill">{notificationIcon[notificationItem.requestCode]}</div>
                    </div>
                </a>

                {/* NOTIFICATION MODALS */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showNotificationModal}
                    onRequestClose={() => { this.handleCloseModal(0) }}
                    contentLabel="Notification"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal(0) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    {relevantNotificationType}
                </ReactModal>
            </React.Fragment>
        );
    }
}



const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        userData: state.firebase.profile,
        notifUtils: state.notifUtils,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
    }
}

export default connect(mapStateToProps)(NotificationControl);